var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.bannerPic,"alt":""}}),_c('div',{staticClass:"banner-content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }